module.exports = __webpack_public_path__ + "680b13f7ed3c6a10561bad83d9f8eba0.jpg";